import React from 'react';
import styles from './About.module.css';
import { FaReact, FaNodeJs, FaHtml5, FaCss3Alt, FaJsSquare, FaGitAlt, FaDocker, FaAws, FaGoogle } from 'react-icons/fa';
import { SiC, SiCplusplus, SiPython, SiR, SiMysql, SiGo, SiSwift, SiAngular, SiDjango, SiFlask, SiPandas, SiPostgresql, SiFirebase } from 'react-icons/si';

const iconSize = '2em';

const About = () => {
  return (
    <section id="about" className={styles.aboutSection}>
      <div className={styles.sectionLabel}>
        <span className={styles.prompt}>$</span> cat about.txt
      </div>

      <div className={styles.flexContainer}>
        <div className={styles.imageContainer}>
          <div className={styles.imageGlow}></div>
          <img
            src={require("../src/Images/dev.png")}
            alt="Dev Kansara"
            className={styles.profileImage}
          />
        </div>
        <div className={styles.textContainer}>
          <h2 className={styles.greeting}>
            Hey, I'm <span className={styles.nameHighlight}>Dev Kansara</span>
          </h2>
          <p className={styles.role}>
            Software Engineer @ <span className={styles.companyHighlight}>XOPS</span>
          </p>
          <div className={styles.bio}>
            <p>
              I'm a Computer Science graduate from USC with a passion for building 
              scalable, high-impact software. From developing robust APIs in Go to 
              crafting responsive front-end experiences in React, I thrive on turning 
              complex problems into elegant solutions.
            </p>
            <p>
              My experience spans full-stack development, cloud architecture (AWS/GCP), 
              and system security, from enterprise platforms at ConnectWise to 
              cybersecurity dashboards at Live Risk Labs. I'm driven by the challenge 
              of building systems that are both performant and maintainable.
            </p>
          </div>
          <div className={styles.quickStats}>
            <div className={styles.stat}>
              <span className={styles.statValue}>MS CS</span>
              <span className={styles.statLabel}>USC '25</span>
            </div>
            <div className={styles.statDivider}></div>
            <div className={styles.stat}>
              <span className={styles.statValue}>Full-Stack</span>
              <span className={styles.statLabel}>Go · React · Cloud</span>
            </div>
            <div className={styles.statDivider}></div>
            <div className={styles.stat}>
              <span className={styles.statValue}>1+ Year</span>
              <span className={styles.statLabel}>SWE Experience</span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.sectionLabel} style={{ marginTop: '80px' }}>
        <span className={styles.prompt}>$</span> ls skills/
      </div>
      <div className={styles.techStackContainer}>
        <div className={styles.techStack}>
          <div className={styles.techIconWrapper} title="C">
            <SiC className={styles.techIcon} size={iconSize} style={{ color: '#A8B9CC' }} />
          </div>
          <div className={styles.techIconWrapper} title="C++">
            <SiCplusplus className={styles.techIcon} size={iconSize} style={{ color: '#00599C' }} />
          </div>
          <div className={styles.techIconWrapper} title="Python">
            <SiPython className={styles.techIcon} size={iconSize} style={{ color: '#3776AB' }} />
          </div>
          <div className={styles.techIconWrapper} title="Go">
            <SiGo className={styles.techIcon} size={iconSize} style={{ color: '#00ADD8' }} />
          </div>
          <div className={styles.techIconWrapper} title="SwiftUI">
            <SiSwift className={styles.techIcon} size={iconSize} style={{ color: '#0074fd' }} />
          </div>
          <div className={styles.techIconWrapper} title="MySQL">
            <SiMysql className={styles.techIcon} size={iconSize} style={{ color: '#4479A1' }} />
          </div>
          <div className={styles.techIconWrapper} title="HTML5">
            <FaHtml5 className={styles.techIcon} size={iconSize} style={{ color: '#E34F26' }} />
          </div>
          <div className={styles.newLine}></div>
          <div className={styles.techIconWrapper} title="CSS3">
            <FaCss3Alt className={styles.techIcon} size={iconSize} style={{ color: '#1572B6' }} />
          </div>
          <div className={styles.techIconWrapper} title="JavaScript">
            <FaJsSquare className={styles.techIcon} size={iconSize} style={{ color: '#F7DF1E' }} />
          </div>
          <div className={styles.techIconWrapper} title="React">
            <FaReact className={styles.techIcon} size={iconSize} style={{ color: '#61DAFB' }} />
          </div>
          <div className={styles.techIconWrapper} title="Angular">
            <SiAngular className={styles.techIcon} size={iconSize} style={{ color: '#DD0031' }} />
          </div>
          <div className={styles.techIconWrapper} title="Django">
            <SiDjango className={styles.techIcon} size={iconSize} style={{ color: '#0b4b33' }} />
          </div>
          <div className={styles.techIconWrapper} title="Flask">
            <SiFlask className={styles.techIcon} size={iconSize} style={{ color: '#FFFFFF' }} />
          </div>
          <div className={styles.techIconWrapper} title="Node.js">
            <FaNodeJs className={styles.techIcon} size={iconSize} style={{ color: '#339933' }} />
          </div>
          <div className={styles.techIconWrapper} title="Git">
            <FaGitAlt className={styles.techIcon} size={iconSize} style={{ color: '#F05032' }} />
          </div>
          <div className={styles.newLine}></div>
          <div className={styles.techIconWrapper} title="R">
            <SiR className={styles.techIcon} size={iconSize} style={{ color: '#276DC3' }} />
          </div>
          <div className={styles.techIconWrapper} title="Docker">
            <FaDocker className={styles.techIcon} size={iconSize} style={{ color: '#2496ED' }} />
          </div>
          <div className={styles.techIconWrapper} title="AWS">
            <FaAws className={styles.techIcon} size={iconSize} style={{ color: '#FF9900' }} />
          </div>
          <div className={styles.techIconWrapper} title="GCP">
            <FaGoogle className={styles.techIcon} size={iconSize} style={{ color: '#4285F4' }} />
          </div>
          <div className={styles.techIconWrapper} title="Pandas">
            <SiPandas className={styles.techIcon} size={iconSize} style={{ color: '#150458' }} />
          </div>
          <div className={styles.techIconWrapper} title="PostgreSQL">
            <SiPostgresql className={styles.techIcon} size={iconSize} style={{ color: '#336791' }} />
          </div>
          <div className={styles.techIconWrapper} title="Firebase">
            <SiFirebase className={styles.techIcon} size={iconSize} style={{ color: '#FFCA28' }} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
